"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgAward01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1a8 8 0 0 0-5.1 14.163l-.891 6.705a1 1 0 0 0 1.506.99L12 20.166l4.485 2.692a1 1 0 0 0 1.506-.99l-.89-6.705A8 8 0 0 0 12 1ZM8.763 16.318c.99.438 2.085.682 3.237.682a7.972 7.972 0 0 0 3.237-.682l.499 3.757-2.81-1.686-.029-.017c-.105-.065-.324-.199-.575-.254a1.498 1.498 0 0 0-.644 0c-.251.055-.47.19-.575.254l-.03.017-2.809 1.686.5-3.757Z", fill: "currentColor" }) }))); };
exports.default = SvgAward01;
